export default "__VITE_ASSET__f60be5dc__"